import React from "react";
import Skeleton from "react-loading-skeleton";

import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import Drawer from "react-modern-drawer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faX} from "@fortawesome/free-solid-svg-icons";

import influxLogo from "../../assets/images/influx-logo.svg";
import modalBanner from "../../assets/images/fnb-items/bg-item680x680-01.png";
import dummyCategoryBanner from "../../assets/images/categoryBanner.jpg";
import dummyItemsBanner from "../../assets/images/itemDummy.jpg";
import alchocolImg from "../../assets/images/ic-alcoholic-80x72.svg";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.osComponentRef1 = React.createRef();
  }

  populateModifierGroupTitle = (mgTitle, minQty, maxQty) => {
    ////////console.log("Footer > populateModifierGroupTitle()");
    var itemModifierGroupTitle = mgTitle;
    if (minQty == 0 && maxQty == 0) {
      itemModifierGroupTitle = itemModifierGroupTitle + " (optional)";
    } else if (minQty == 0 && maxQty == 1) {
      itemModifierGroupTitle = itemModifierGroupTitle + " (optional select up to 1)";
    } else if (minQty == 1 && maxQty == 1) {
      itemModifierGroupTitle = itemModifierGroupTitle + " (Required)";
    } else if (minQty == 0 && maxQty > 1 && maxQty > minQty) {
      itemModifierGroupTitle = itemModifierGroupTitle + " (optional select up to " + maxQty + ")";
    } else if (minQty > 0 && maxQty > 1 && maxQty == minQty) {
      itemModifierGroupTitle = itemModifierGroupTitle + " (Required select " + maxQty + ")";
    } else if (minQty > 0 && maxQty > 1 && maxQty > minQty) {
      itemModifierGroupTitle = itemModifierGroupTitle + " (Required select " + minQty + " up to " + maxQty + ")";
    }
    return itemModifierGroupTitle;
  };


  alchocolDetailsMessage = () => {
    var tempAlchocolDetailsData = this.props.appState.alchocolDetailsData;
    var message = '';
    if(Object.keys(tempAlchocolDetailsData.length > 0) && tempAlchocolDetailsData.Popup_message1){
      var getMsg = tempAlchocolDetailsData.Popup_message1;
      var splitArray = getMsg.split(".");
      if(splitArray.length > 1){
        message = splitArray.map((dataMsg, index) => {
          return dataMsg != '' ? (
            <p>{dataMsg}{index == splitArray.length - 1 ? '':'.'}</p>
          ):null
        })
      }else{
        message = <p>{getMsg}</p>
      }
    }
    return message;
  }
  
  render() {
    return (
      <>
        <footer className="footer pageFooter">
          Powered by
          <a href="https://www.influxworldwide.com/cinemas/" title="Influx Worldwide" target="_blank">
            <img src={influxLogo}></img>
          </a>
        </footer>
        <section className="fnbmodifierModal">
          <Drawer open={this.props.appState.modifiersModalDrawer} onClose={this.props.hideModifiersDrawer} direction="bottom" size="90%" overlayOpacity="0.75">
            <a className="drawerClose" href="javascript:;" onClick={() => this.props.hideModifiersDrawer()}>
              <i>&nbsp;</i>
            </a>
            <section
              id="modalFnbModifier"
              className="modal fade show d-block"
              tabIndex="-1"
              // role="dialog"
              // data-bs-keyboard="false"
              // data-bs-backdrop="static"
            >
              <section className="modal-dialog" role="document">
                <section className="modal-content mfSingleRow">
                  <OverlayScrollbarsComponent
                    ref={this.osComponentRef1}
                    options={{
                      paddingAbsolute: true,
                      autoUpdate: true,
                      scrollbars: {
                        clickScrolling: true,
                      },
                    }}
                    className="osbWrap"
                  >
                    {/* {Object.keys(this.props.appState.fnbItemData).length > 0 && this.props.appState.fnbItemModifierData.length > 0 ? ( */}
                    {Object.keys(this.props.appState.fnbItemData).length > 0 ? (
                      <>
                        <section
                          className="modal-header"
                          style={{
                            // backgroundImage: "url(" + this.props.appState.fnbItemData.IsImage == 1 ? this.props.appState.fnbItemData.image_url : dummyItemsBanner + ")",
                            // height: 175,
                            backgroundImage: this.props.appState.fnbItemData.IsImage == 1 ? "url(" + this.props.appState.fnbItemData.image_url + ")" : "url(" + dummyItemsBanner + ")",
                          }}
                        >
                          <img
                            src={this.props.appState.fnbItemData.IsImage == 1 ? this.props.appState.fnbItemData.image_url : dummyItemsBanner}
                            alt={this.props.appState.fnbItemData.Name}
                            className="img-fluid d-md-none"
                          />
                          <div className="todaysDealCloseDiv d-none">
                            {/* {this.props.populateTodaysDealFlag(this.props.appState.fnbItemModifierData.id) ? (
                              <button type="button" className="btn btn-primary todaysDealPill">
                                Today's Deal
                              </button>
                            ) : (
                              <span></span>
                            )} */}
                            <span></span>
                            <a
                              href="javascript:;"
                              className="modalClose"
                              title="Close"
                              //data-bs-dismiss="modal"
                              //aria-label="Close"
                              //onClick={() => this.props.modifierModalToggleDrawer()}
                              onClick={() => this.props.hideModifiersDrawer()}
                            >
                              Modal Close
                            </a>
                          </div>
                        </section>
                        <section className="modal-body">
                          <section className="fnbItemdesc">
                            <h2>{this.props.appState.fnbItemData.Name}</h2>
                            <p>
                              {this.props.appState.fnbItemData.calories != "" ? <strong>{this.props.appState.fnbItemData.calories} | </strong> : ""}
                              {this.props.appState.fnbItemData.Description}
                            </p>
                          </section>
                          <section className="fnbmmRowwrap">
                            {/* Alternate Items */}
                            {/* {this.props.appState.fnbItemModifierData.fnbs_alternateitems && this.props.appState.fnbItemModifierData.fnbs_alternateitems.length > 0 ? (
                              <section
                                //className="fnbmmrwRows fnbsubItemsrows"
                                className="fnbmmrwRows fnbAlternateItems"
                              >
                                <section className="fnbmmrwrsiWrap">
                                  <h3>Select an option</h3>
                                  <ul>
                                    {this.props.appState.fnbItemModifierData.fnbs_alternateitems.map((alternateItem, index) => {
                                      return (
                                        <li key={"alternateItemKey" + this.props.appState.fnbItemModifierData.id + "_" + alternateItem.id + "_" + index}>
                                          <aside className="customRadio">
                                            <input
                                              type="radio"
                                              id={"alternateItemRadio" + this.props.appState.fnbItemModifierData.id + "_" + alternateItem.id + "_" + index}
                                              name="selectFnbsAlternateitems"
                                              onChange={(e) => this.props.alternateItemRadioOnchange(alternateItem, this.props.appState.fnbItemModifierData.ageRestriction)}
                                            />
                                            <label htmlFor={"alternateItemRadio" + this.props.appState.fnbItemModifierData.id + "_" + alternateItem.id + "_" + index}>
                                              {alternateItem.itemName}
                                              <span>{`$${
                                                alternateItem.strikeprice == -1 || alternateItem.strikeprice == null
                                                  ? alternateItem.valuebeforetax.toFixed(2)
                                                  : alternateItem.strikeValueBeforeTax.toFixed(2)
                                              }`}</span>
                                              <i></i>
                                            </label>
                                          </aside>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </section>
                              </section>
                            ) : (
                              ""
                            )} */}
                            {/* E.O.Alternate Items */}
                            {/* Modifier Groups */}
                            {this.props.appState.fnbItemModifierData.length > 0 ? (
                              <section className="fnbmmrwRows fnbsubItemsrows">
                                {this.props.appState.fnbItemModifierData.map((modifierGroup, index) => {
                                  return (
                                    <section
                                      className="fnbmmrwrsiWrap"
                                      key={"modifierGroups" + this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId + "_" + index}
                                      //tabId
                                      id={"fnbmmrwrsiWrap_" + this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId}
                                    >
                                      <h3>{this.populateModifierGroupTitle(modifierGroup.Name, modifierGroup.MinimumItems, modifierGroup.MaximumItems)}</h3>
                                      {modifierGroup.ModifierItems.length > 0 ? (
                                        modifierGroup.MinimumItems == 1 && modifierGroup.MaximumItems == 1 ? (
                                          <ul>
                                            {modifierGroup.ModifierItems.map((modifierItem, index) => {
                                              return (
                                                <li
                                                  key={"modifierItem" + this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId + "_" + modifierItem.ModifierId + "_" + index}
                                                >
                                                  <aside className="customRadio">
                                                    <input
                                                      type="radio"
                                                      id={"cb" + this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId + "_" + modifierItem.ModifierId + "_" + index}
                                                      // name="selectOptions"
                                                      name={`selectOptions_${this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId}`}
                                                      // onChange={(e) =>
                                                      //   this.props.modifierItemRadioOnchange(
                                                      //     e,
                                                      //     this.props.appState.fnbItemModifierData.id,
                                                      //     modifierGroup.id,
                                                      //     modifierGroup.tabid,
                                                      //     modifierGroup.minQty,
                                                      //     modifierGroup.maxQty,
                                                      //     modifierItem.id,
                                                      //     modifierItem.itemName,
                                                      //     modifierItem.valuebeforetax,
                                                      //     modifierItem.taxValue,
                                                      //     modifierItem.strikeprice,
                                                      //     modifierItem.strikeValueBeforeTax,
                                                      //     modifierItem.strikeTaxValue
                                                      //   )
                                                      // }
                                                      onChange={(e) =>
                                                        this.props.modifierItemRadioOnchange(
                                                          e,
                                                          this.props.appState.fnbItemData.MenuItemId,
                                                          modifierGroup.ModifierGroupId,
                                                          "", // modifierGroup.tabid,
                                                          modifierGroup.MinimumItems,
                                                          modifierGroup.MaximumItems,
                                                          modifierItem.ModifierId,
                                                          modifierItem.Name,
                                                          Number(modifierItem.Price),
                                                          0, // modifierItem.taxValue,
                                                          -1, // modifierItem.strikeprice,
                                                          0, // modifierItem.strikeValueBeforeTax,
                                                          0 // modifierItem.strikeTaxValue
                                                        )
                                                      }
                                                    />
                                                    <label
                                                      htmlFor={"cb" + this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId + "_" + modifierItem.ModifierId + "_" + index}
                                                    >
                                                      {modifierItem.Name}
                                                      {modifierItem.Price > 0 ? <span>+ {modifierItem.Price}</span> : ""}
                                                      <i></i>
                                                    </label>
                                                  </aside>
                                                </li>
                                              );
                                            })}
                                          </ul>
                                        ) : (
                                          <ul>
                                            {modifierGroup.ModifierItems.map((modifierItem, index) => {
                                              // return modifierItem.valuebeforetax > 0 ? (
                                              return modifierItem.Price > 0 ? (
                                                <li
                                                  key={"modifierItem" + this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId + "_" + modifierItem.ModifierId + "_" + index}
                                                >
                                                  <section className="additionalItems">
                                                    <h4>
                                                      {modifierItem.Name} <strong className="modifierCalInfo">| 50 Cal</strong>
                                                      <span>{`+ $${modifierItem.Price}`}</span>
                                                      {/* <span> {"+ $" + (this.props.appState.fnbItemModifierData.strikeprice == -1 ? modifierItem.valuebeforetax.toFixed(2) : modifierItem.strikeValueBeforeTax.toFixed(2))} </span> */}
                                                    </h4>
                                                    {/* <span>
                                                      {"$" +
                                                        modifierItem.valuebeforetax}
                                                    </span> */}
                                                    <aside className="itemCounter icZero iczActive">
                                                      <a
                                                        href="javascript:;"
                                                        className="icControl iccDecrement disabled"
                                                        title="-"
                                                        // onClick={(e) =>
                                                        //   this.props.modifierItemCounter(
                                                        //     e,
                                                        //     "countDecrement",
                                                        //     this.props.appState.fnbItemModifierData.id,
                                                        //     modifierGroup.id,
                                                        //     modifierGroup.tabid,
                                                        //     modifierGroup.minQty,
                                                        //     modifierGroup.maxQty,
                                                        //     modifierItem.id,
                                                        //     modifierItem.itemName,
                                                        //     ////this.props.appState.fnbItemModifierData.strikeprice == -1 ? modifierItem.valuebeforetax : modifierItem.strikeValueBeforeTax,
                                                        //     ////this.props.appState.fnbItemModifierData.strikeprice == -1 ? modifierItem.taxValue : modifierItem.strikeTaxValue
                                                        //     modifierItem.valuebeforetax,
                                                        //     modifierItem.taxValue,
                                                        //     modifierItem.strikeprice,
                                                        //     modifierItem.strikeValueBeforeTax,
                                                        //     modifierItem.strikeTaxValue
                                                        //   )
                                                        // }
                                                        onClick={(e) =>
                                                          this.props.modifierItemCounter(
                                                            e,
                                                            "countDecrement",
                                                            this.props.appState.fnbItemData.MenuItemId,
                                                            modifierGroup.ModifierGroupId,
                                                            "", // modifierGroup.tabid,
                                                            modifierGroup.MinimumItems,
                                                            modifierGroup.MaximumItems,
                                                            modifierItem.ModifierId,
                                                            modifierItem.Name,
                                                            Number(modifierItem.Price),
                                                            0, // modifierItem.taxValue,
                                                            -1, // modifierItem.strikeprice,
                                                            0, // modifierItem.strikeValueBeforeTax,
                                                            0 // modifierItem.strikeTaxValue
                                                          )
                                                        }
                                                      >
                                                        <span>Decrement</span>
                                                      </a>
                                                      <input
                                                        type="text"
                                                        //value="0"
                                                        defaultValue="0"
                                                        className="form-control"
                                                        readOnly
                                                      />
                                                      <a
                                                        href="javascript:;"
                                                        className="icControl iccIncrement"
                                                        title="+"
                                                        // onClick={(e) =>
                                                        //   this.props.modifierItemCounter(
                                                        //     e,
                                                        //     "countIncrement",
                                                        //     this.props.appState.fnbItemModifierData.id,
                                                        //     modifierGroup.id,
                                                        //     modifierGroup.tabid,
                                                        //     modifierGroup.minQty,
                                                        //     modifierGroup.maxQty,
                                                        //     modifierItem.id,
                                                        //     modifierItem.itemName,
                                                        //     ////this.props.appState.fnbItemModifierData.strikeprice == -1 ? modifierItem.valuebeforetax : modifierItem.strikeValueBeforeTax,
                                                        //     ////this.props.appState.fnbItemModifierData.strikeprice == -1 ? modifierItem.taxValue : modifierItem.strikeTaxValue
                                                        //     modifierItem.valuebeforetax,
                                                        //     modifierItem.taxValue,
                                                        //     modifierItem.strikeprice,
                                                        //     modifierItem.strikeValueBeforeTax,
                                                        //     modifierItem.strikeTaxValue
                                                        //   )
                                                        // }
                                                        onClick={(e) =>
                                                          this.props.modifierItemCounter(
                                                            e,
                                                            "countIncrement",
                                                            this.props.appState.fnbItemData.MenuItemId,
                                                            modifierGroup.ModifierGroupId,
                                                            "", // modifierGroup.tabid,
                                                            modifierGroup.MinimumItems,
                                                            modifierGroup.MaximumItems,
                                                            modifierItem.ModifierId,
                                                            modifierItem.Name,
                                                            Number(modifierItem.Price),
                                                            0, // modifierItem.taxValue,
                                                            -1, // modifierItem.strikeprice,
                                                            0, // modifierItem.strikeValueBeforeTax,
                                                            0 // modifierItem.strikeTaxValue
                                                          )
                                                        }
                                                      >
                                                        <span>Increment</span>
                                                      </a>
                                                    </aside>
                                                  </section>
                                                </li>
                                              ) : (
                                                <li
                                                  key={"modifierItem" + this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId + "_" + modifierItem.ModifierId + "_" + index}
                                                >
                                                  <aside className="customCheckbox">
                                                    <input
                                                      type="checkbox"
                                                      id={"cb" + this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId + "_" + modifierItem.ModifierId + "_" + index}
                                                      // name="selectOptions"
                                                      name={`selectOptions_${this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId}`}
                                                      // onChange={(e) =>
                                                      //   this.props.modifierItemCheckboxOnchange(
                                                      //     e,
                                                      //     this.props.appState.fnbItemModifierData.id,
                                                      //     modifierGroup.id,
                                                      //     modifierGroup.tabid,
                                                      //     modifierGroup.minQty,
                                                      //     modifierGroup.maxQty,
                                                      //     modifierItem.id,
                                                      //     modifierItem.itemName,
                                                      //     modifierItem.valuebeforetax,
                                                      //     modifierItem.taxValue,
                                                      //     modifierItem.strikeprice,
                                                      //     modifierItem.strikeValueBeforeTax,
                                                      //     modifierItem.strikeTaxValue
                                                      //   )
                                                      // }
                                                      onChange={(e) =>
                                                        this.props.modifierItemCheckboxOnchange(
                                                          e,
                                                          this.props.appState.fnbItemData.MenuItemId,
                                                          modifierGroup.ModifierGroupId,
                                                          "", // modifierGroup.tabid,
                                                          modifierGroup.MinimumItems,
                                                          modifierGroup.MaximumItems,
                                                          modifierItem.ModifierId,
                                                          modifierItem.Name,
                                                          Number(modifierItem.Price),
                                                          0, // modifierItem.taxValue,
                                                          -1, // modifierItem.strikeprice,
                                                          0, // modifierItem.strikeValueBeforeTax,
                                                          0 // modifierItem.strikeTaxValue
                                                        )
                                                      }
                                                    />
                                                    <label
                                                      htmlFor={"cb" + this.props.appState.fnbItemData.MenuItemId + "_" + modifierGroup.ModifierGroupId + "_" + modifierItem.ModifierId + "_" + index}
                                                    >
                                                      {modifierItem.Name}
                                                      <i></i>
                                                    </label>
                                                  </aside>
                                                </li>
                                              );
                                            })}
                                          </ul>
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </section>
                                  );
                                })}
                              </section>
                            ) : (
                              <section className="fnbmmrwRows fnbsubItemsrows">
                                <div style={{marginTop: 10, marginBottom: 20}}>
                                  <Skeleton height={30} duration={0.75} />
                                </div>
                                <div>
                                  <div style={{marginBottom: 10}}>
                                    <div style={{width: "50%", display: "inline-block"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                    <div style={{width: "25%", display: "inline-block", marginLeft: "25%"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                  </div>
                                  <div style={{marginBottom: 10}}>
                                    <div style={{width: "50%", display: "inline-block"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                    <div style={{width: "25%", display: "inline-block", marginLeft: "25%"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                  </div>
                                  <div style={{marginBottom: 10}}>
                                    <div style={{width: "50%", display: "inline-block"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                    <div style={{width: "25%", display: "inline-block", marginLeft: "25%"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                  </div>
                                  <div style={{marginBottom: 10}}>
                                    <div style={{width: "50%", display: "inline-block"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                    <div style={{width: "25%", display: "inline-block", marginLeft: "25%"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                  </div>
                                  <div style={{marginBottom: 10}}>
                                    <div style={{width: "50%", display: "inline-block"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                    <div style={{width: "25%", display: "inline-block", marginLeft: "25%"}}>
                                      <Skeleton height={25} duration={0.75} />
                                    </div>
                                  </div>
                                </div>
                              </section>
                            )}
                            <section className="fnbmmrwRows modModalSpecialInstruction">
                              <h3>Special Instructions <span>(Maximum 27 characters)</span></h3>
                              <section className="form-group">
                                <label className="visually-hidden">Special Instructions</label>
                                <textarea
                                  className="form-control"
                                  placeholder="Enter your instructions here"
                                  value={
                                    this.props.appState.cartData[this.props.appState.cartData.length - 1] === undefined
                                      ? ""
                                      : this.props.appState.cartData[this.props.appState.cartData.length - 1].specialinstructions
                                  }
                                  onChange={(e) => this.props.modifierModalFnbItemSpecialInstructions(e)}
                                  maxLength="27"
                                ></textarea>
                                {
                                  this.props.appState.cartData.length > 0 ?
                                  <p className="maxCharInfo">{this.props.appState.cartData[this.props.appState.cartData.length - 1].specialinstructions == "" ? 0 : this.props.appState.cartData[this.props.appState.cartData.length - 1].specialinstructions.length }/27</p>
                                  :''
                                }
                              </section>
                            </section>
                          </section>
                        </section>
                      </>
                    ) : (
                      ""
                    )}
                  </OverlayScrollbarsComponent>
                  <section className="modal-footer mfSingleRow">
                    <section className="fnbQuantity clearfix" id="modalFnbItemQuantity">
                      <h5 className="d-none d-md-block">Quantity</h5>
                      <aside className="itemCounter icLarge">
                        <a
                          href="javascript:;"
                          id="modiferModalDecrementBtn"
                          className="icControl iccDecrement disabled"
                          title="-"
                          onClick={(e) => this.props.modifierModalFnbItemQuantity(e, "countDecrement", this.props.appState.fnbItemData, this.props.appState.fnbItemModifierData)}
                        >
                          <span>Decrement</span>
                        </a>
                        <input type="text" defaultValue="1" className="form-control" readOnly id="modalFnbModifierQuantity" />
                        <a
                          href="javascript:;"
                          id="modiferModalIncrementBtn"
                          className="icControl iccIncrement"
                          title="+"
                          onClick={(e) => this.props.modifierModalFnbItemQuantity(e, "countIncrement", this.props.appState.fnbItemData, this.props.appState.fnbItemModifierData)}
                        >
                          <span>Increment</span>
                        </a>
                      </aside>
                    </section>
                    <section className="fnbmmAction">
                      <aside className="btnswrap">
                        {this.props.appState.fnbItemModifierData.fnbs_alternateitems && this.props.appState.fnbItemModifierData.fnbs_alternateitems.length > 0 ? (
                          <a
                            href="javascript:;"
                            className="btn btndefault"
                            title={`Add to Order${this.props.tempModifierModalTotal > 0 ? " &" + this.props.tempModifierModalTotal + "" : ""}`}
                            onClick={alert("Alternateitems Btn Click.")}
                            id="modifierModalBtn"
                          >
                            {`Add to Order${this.props.tempModifierModalTotal > 0 ? " $" + this.props.tempModifierModalTotal + "" : ""}`}
                          </a>
                        ) : (
                          <a
                            href="javascript:;"
                            className="btn btndefault"
                            title={`Add to Order $${
                              this.props.appState.tempModifierModalTotal > 0 ? this.props.appState.tempModifierModalTotal : Number(this.props.appState.fnbItemData.Price).toFixed(2)
                            }`}
                            onClick={() => {
                              this.props.addItemToCart(this.props.appState.fnbItemData.MenuItemId);
                              this.props.hideModifiersDrawer();
                              // // // // // // // // // // if (this.props.appState.fnbItemData.Upsize == "1") {
                              // // // // // // // // // //   var self = this;
                              // // // // // // // // // //   self.props.showUpsizeDrawer();
                              // // // // // // // // // // }
                            }}
                            id="modifierModalBtn"
                          >
                            {`Add to Order $${this.props.appState.tempModifierModalTotal > 0 ? this.props.appState.tempModifierModalTotal : Number(this.props.appState.fnbItemData.Price).toFixed(2)}`}
                          </a>
                        )}
                      </aside>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </Drawer>

          <Drawer
            open={this.props.appState.upsizeModalDrawerFlag}
            onClose={this.props.hideUpsizeDrawer}
            direction="bottom"
            // size="90%"
            size="75%"
            overlayOpacity="0.75"
          >
            <section id="upsizeModal" className="modal fade show d-block" tabIndex="-1">
              <section className="modal-dialog" role="document">
                <section className="modal-content mfSingleRow">
                  {Object.keys(this.props.appState.fnbItemData).length > 0 ? (
                    this.props.appState.fnbItemData.Upsize == "1" ? (
                      <>
                        <section className="modal-body">
                          <section className="fnbItemdesc" style={{paddingBottom: 20, paddingTop: 20}}>
                            <h2 style={{fontSize: 22, lineHeight: "22px", marginBottom: 0, padding: 0, textAlign: "center", color: "#8d181b"}}>
                              {this.props.appState.fnbItemData.UpsizeMenuItems[0].UpSizeTitle}
                            </h2>
                          </section>
                        </section>
                        <section
                          style={{
                            height: 250,
                            backgroundImage:
                              this.props.appState.fnbItemData.IsImage == 1 ? "url(" + this.props.appState.fnbItemData.UpsizeMenuItems[0].image_url + ")" : "url(" + dummyItemsBanner + ")",
                            backgroundPosition: "center",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={this.props.appState.fnbItemData.IsImage == 1 ? this.props.appState.fnbItemData.UpsizeMenuItems[0].image_url : dummyItemsBanner}
                            alt={this.props.appState.fnbItemData.Name}
                            className="img-fluid d-md-none"
                          />
                        </section>
                        <section className="modal-body">
                          <section className="fnbItemdesc" style={{paddingBottom: 0, paddingTop: 0}}>
                            <p className="text-center" style={{marginBottom: 10}}>
                              You have selected {this.props.appState.fnbItemData.Name}
                            </p>
                            <h2 style={{fontSize: 22, lineHeight: "22px", marginBottom: 0, padding: 0, textAlign: "center"}}>
                              Would you like to add a {this.props.appState.fnbItemData.UpsizeMenuItems[0].Name} instead?
                            </h2>
                          </section>
                        </section>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  <section className="modal-footer mfSingleRow">
                    <section className="fnbmmAction">
                      <aside className="btnswrap d-flex justify-content-center" style={{marginBottom: 25}}>
                        <a
                          href="javascript:;"
                          className="btn btndefault"
                          title={`No`}
                          id="upsizeNoBtn"
                          // style={{fontSize: 16}}
                          // onClick={() => this.props.hideUpsizeDrawer()}
                          onClick={() => this.props.upsizeItem(false)}
                        >
                          N0, THANKS!
                        </a>
                        <a
                          href="javascript:;"
                          className="btn btndefault"
                          title={`Yes`}
                          id="upsizeYesBtn"
                          style={{paddingLeft: 25, paddingRight: 25}}
                          // onClick={() => this.props.upsizeItem()}
                          onClick={() => this.props.upsizeItem(true)}
                        >
                          ADD
                        </a>
                      </aside>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </Drawer>
        </section>
        {/* E.O.Modal Popup | FnB Modifier */}
        <section className="common-popup-modal">
          <Drawer
            open={this.props.appState.repeatItemModalDrawer}
            onClose={this.props.closeRepeatItemDrawer}
            direction="bottom"
            className="repeatItemDrawer"
            //  size="90%"
            size="75%"
          >
            <section
              id="repeatItem"
              // className="common-popupCont res-btmCont modal fade"
              className="common-popupCont res-btmCont modal fade show d-block"
              // role="dialog"
              // data-bs-keyboard="false"
              // data-bs-backdrop="static"
            >
              <section className="modal-dialog">
                <section className="modal-content">
                  <section className="modal-body">
                    {/* <FontAwesomeIcon icon={faX} className="modalClose fontAwesomeClose" data-bs-dismiss="modal"></FontAwesomeIcon> */}
                    {/* <a href="javascript:;" className="modalClose" data-bs-dismiss="modal" title="Close">
                    Close
                    </a> */}
                    {/* <h2>Classic Popcorn</h2> */}
                    <h2 id="repeatItemTitle">
                      You made it your way!<p className="howAboutThisTime">How about this time?</p>
                    </h2>

                    <p className="repeatItemName">
                      {Object.keys(this.props.appState.repeatItemData) !== 0 && this.props.appState.repeatItemData.itemName ? this.props.appState.repeatItemData.itemName : ""}
                    </p>
                    {(Object.keys(this.props.appState.repeatItemData) !== 0 && this.props.appState.repeatItemData.modifierGroups && this.props.appState.repeatItemData.modifierGroups.length > 0) ||
                    (this.props.appState.repeatItemData.smartModifiers && this.props.appState.repeatItemData.smartModifiers.length > 0) ? (
                      <>
                        {/* <p className="gpara"> White chocolate chips, Milk chocolate chips, <br /> Popped popcorn plain </p>  */}
                        <p className="gpara" id="repeatItemModifiers">
                          {this.props.populateItemModifierItems(this.props.appState.repeatItemData.modifierGroups, this.props.appState.repeatItemData.smartModifiers)}
                          {/* {this.props.populateItemSmartModifierItems(this.props.appState.repeatItemData.smartModifiers)} */}
                        </p>
                      </>
                    ) : (
                      ""
                    )}

                    <aside className="btnswrap">
                      <a
                        href="javascript:;"
                        className="btn btnprimary"
                        title="Let me choose"
                        // data-bs-dismiss="modal"
                        onClick={(event) => this.props.handleRepeatillChoose(event)}
                      >
                        <span>Let me choose</span>
                      </a>
                      <a
                        href="javascript:;"
                        className="btn btndefault"
                        title="Repeat, please"
                        // data-bs-dismiss="modal"
                        onClick={(event) => this.props.handleRepeatPreviousSelection(event)}
                      >
                        <span>Repeat, please</span>
                      </a>
                    </aside>
                  </section>
                </section>
              </section>
            </section>
          </Drawer>
        </section>
        {/* E.O.Modal Popup | Repeat Item */}

        {/* E.O.Modal Popup | Allow Alcoholic */}
        <section id="allowAlcoholic" className="common-popupCont modal fade" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
          <section className="modal-dialog modal-dialog-centered">
            <section className="modal-content">
              <section className="modal-body">
                <a href="javascript:;" className="modalClose" data-bs-dismiss="modal" title="Close">
                  Close
                </a>
                <section className="contentWrap">
                  {/* <p>{Object.keys(this.props.appState.alchocolDetailsData.length > 0) ? this.props.appState.alchocolDetailsData.Popup_message1:''}</p> */}
                  <img src={alchocolImg} alt='Alcoholic' className="img-fluid alcoholicImg" />
                  <aside className="contentPara">
                    {this.alchocolDetailsMessage()}
                  </aside>
                  <aside className="checkboxSec">
                    <input 
                      onChange={(e) => this.props.alcoholOnChange(e)} 
                      type="checkbox" 
                      id="ageCheckbox" 
                      checked={this.props.appState.alcoholDisableBtn ? true:false}
                    />
                    <label for="ageCheckbox">{Object.keys(this.props.appState.alchocolDetailsData.length > 0) ? this.props.appState.alchocolDetailsData.Popup_message2:''}<i>&nbsp;</i></label>
                  </aside>
                </section>
                <aside className="btnswrap">
                  <a onClick={this.props.alchocolOkBtn} href="javascript:;" className={`btn ${this.props.appState.alcoholDisableBtn ? '':'disabled'}`} id="ageRestrictionBtn" title="Ok" data-bs-dismiss="modal">
                    <span>Ok</span>
                  </a>
                </aside>
              </section>
            </section>
          </section>
        </section>
        {/* E.O.Modal Popup | Allow Alcoholic */}

        {/* Sales Items > modal > start */}
    <section className="fnbmodifierModal sales-items-popup">
      <Drawer
        open={this.props.appState.salesItemModalDrawer}
        onClose={this.props.closeSalesItemDrawer}
        direction="bottom"
        className="salesItemDrawer"
        // size="75%"
      >
        <a onClick={this.props.salesItemDrawerCloseBtn} class="drawerClose" href="javascript:;"><i>&nbsp;</i></a>
        <section className="modal fade show d-block" tabIndex="-1">
          <section className="modal-dialog" role="document">
            <section className="modal-content mfSingleRow">
              <section className="modal-body">
                <section class="fnbItemdesc">
                  <h2>{this.props.appState.fnbItemData.Name}</h2>
                  <p>{this.props.appState.fnbItemData.Description}</p>
                </section>
                {
                  Object.keys(this.props.appState.fnbItemData).length > 0 && this.props.appState.fnbItemData.SalesItemId.length > 1 ?
                  <section className="fnbmmRowwrap">
                    <section className="fnbmmrwRows">
                        <ul>
                          {
                            this.props.appState.fnbItemData.SalesItemId.map((salesData, index) => {
                              return(
                                <li>
                                  <aside class="customRadio">
                                    <input 
                                      onChange={(e) => this.props.salesItemsOnchange(e, salesData)} 
                                      type="radio" 
                                      id={`sales_${index}`} 
                                      name="salesOptions" 
                                      />
                                    <label htmlFor={`sales_${index}`}>{salesData.Name}<i></i></label>
                                  </aside>
                                </li>
                              )
                            })
                          }
                        </ul>
                    </section>
                  </section>:null
                }
                <section className="fnbmmAction">
                  <aside className="btnswrap">
                    <a 
                      onClick={this.props.salesItemsSubmit} 
                      className={`btn btndefault ${Object.keys(this.props.appState.salesItemsData).length > 0 ? '':'disabled'}`} 
                      href="javascript:;" 
                      title="Submit"
                    >
                      Submit
                    </a>
                  </aside>
                </section>
              </section>
            </section>
          </section>
        </section>
      </Drawer>
    </section>
    {/* Sales Items > modal > end */}

    </>
    );
  }
}

export default Footer;
